var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSpiderGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.25,7.25h-0.3c-0.34-2.71-2.49-4.86-5.2-5.2v-0.3C8.75,1.34,8.41,1,8,1S7.25,1.34,7.25,1.75v0.3 c-2.71,0.34-4.86,2.49-5.2,5.2h-0.3C1.34,7.25,1,7.59,1,8s0.34,0.75,0.75,0.75h0.3c0.34,2.71,2.49,4.86,5.2,5.2v0.3 C7.25,14.66,7.59,15,8,15s0.75-0.34,0.75-0.75v-0.3c2.71-0.34,4.86-2.49,5.2-5.2h0.3C14.66,8.75,15,8.41,15,8 C15,7.58,14.66,7.25,14.25,7.25z M13.44,7.25H8.75V2.56C11.18,2.89,13.11,4.82,13.44,7.25z M7.25,2.56v4.69H2.56 C2.89,4.82,4.82,2.89,7.25,2.56z M2.56,8.75h4.69v4.69C4.82,13.11,2.89,11.18,2.56,8.75z M8.75,13.44V8.75h4.69 C13.11,11.18,11.18,13.11,8.75,13.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSpiderGrid);
export default __webpack_public_path__ + "static/media/icons_spider-grid.6b4c1bc8ae432851c4d4f6ca58c3969d.svg";
export { ForwardRef as ReactComponent };